import { Dayjs } from 'dayjs';

export enum UpdateType {
  ADD = 'ADD',
  REPLACE = 'REPLACE',
}
export enum ShiftStatusType {
  DELETED = 'DELETED',
  BOOKED = 'BOOKED',
  OPEN = 'OPEN',
  WISH = 'WISH',
  REQUESTED = 'REQUESTED',
  DECLINED = 'DECLINED',
  DISPATCH_DECLINED = 'DISPATCH_DECLINED',
  CANCELED = 'CANCELED',
}
export const ExtraWorkConst: { [key: string]: ExtraWork } = {
  SORT13: { typeOfExtraWork: 'SORT', payment: 750 },
  SORT14: { typeOfExtraWork: 'SORT', payment: 562 },
  SORT: { typeOfExtraWork: 'SORT', payment: 375 },
  SORT282: { typeOfExtraWork: 'SORT', payment: 282 },
  SORT187: { typeOfExtraWork: 'SORT', payment: 187 },
  BACKUP: { typeOfExtraWork: 'BACKUP', payment: 200 },
  INBOUND: { typeOfExtraWork: 'INBOUND', payment: 500 },
};

export const shiftSortingStartTime = '15.00';

export const ExtraWorkToggleBoxes: {
  extraWorkObj: ExtraWork;
  description: string;
}[] = [
  {
    extraWorkObj: ExtraWorkConst.SORT,
    description: 'Sorting',
  },
  {
    extraWorkObj: ExtraWorkConst.SORT282,
    description: 'Sorting',
  },
  {
    extraWorkObj: ExtraWorkConst.SORT187,
    description: 'Sorting',
  },
  {
    extraWorkObj: ExtraWorkConst.SORT13,
    description: '13:00 Sorting',
  },
  {
    extraWorkObj: ExtraWorkConst.SORT14,
    description: '14:00 Sorting',
  },
  {
    extraWorkObj: ExtraWorkConst.INBOUND,
    description: 'Inbound',
  },
  {
    extraWorkObj: ExtraWorkConst.BACKUP,
    description: 'Backup',
  },
];

export const EmptyShift = {
  name: 'open spot',
  courierId: null,
  status: ShiftStatusType.OPEN,
  note: '',
  extraWork: [],
  shiftTravelMode: 'OPEN',
};

export const EmptyShiftWithId: ShiftCourierJson = {
  id: '123',
  name: 'open spot',
  courierId: null,
  status: ShiftStatusType.OPEN,
  note: '',
  extraWork: [],
  shiftTravelMode: 'OPEN',
};

export interface ShiftCourierJson {
  id: string;
  name: string;
  courierId: number;
  note: string;
  extraWork: ExtraWork[];
  status: ShiftStatusType;
  shiftTravelMode: string;
}

export interface ExtraWork {
  typeOfExtraWork: string;
  payment: number;
}
export interface GroupByShiftListOnShiftTravelModeType {
  BIKE: ShiftCourierJson[];
  CAR: ShiftCourierJson[];
}

export interface ShiftCourierJsonForCourier {
  id: string;
  name: string;
  courierId: number;
  status: ShiftStatusType;
  extraWork: ExtraWork[];
}

export interface ShiftCourierJsonRequest {
  id: string;
  name: string;
  day: string;
  courierId: number;
  note: string;
  status: ShiftStatusType;
  shiftTravelMode: string;
}

export interface ShiftCourierWithDateJson {
  date: Dayjs;
  courierDayBooked: ShiftCourierJson[];
}

export interface ShiftExtraWork {
  description: string;
  extraWorkObj: ExtraWork;
}

export const RatingConst = {
  avgRating1: { value: 1, emoji: '😠' },
  avgRating2: { value: 2, emoji: '😠' },
  avgRating3: { value: 3, emoji: '😠' },
  avgRating4: { value: 4, emoji: '😅' },
  avgRating5: { value: 4.5, emoji: '🙂' },
  avgRating6: { value: 4.75, emoji: '😃' },
  avgRating7: { value: 5, emoji: '😍' },
};

export const TimesBookedConst = {
  nrOfTimesBooked1: { value: 1, emoji: '❄️' },
  nrOfTimesBookedUnder: { value: 2, emoji: '❄️' },
  nrOfTimesBookedOver: {
    value: 2,
    emoji: '🔥',
  },
  nrOfTimesBookedElse: { value: 0, emoji: '❄️' },
};
